import $ from "jquery"; // Import jQuery
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Http from "../../../../Common/Http";
import IsLogin from "../../../../Common/IsLogin";
import { LoaderComponent } from "../../../../Common/LoaderComponent";
import useRequiredFields from "../../../../../hooks/useRequiredFields";
import Select from "react-select";
const Create = () => {
  const navigate = useNavigate();
  const { checkRequiredFields } = useRequiredFields();
  const [selectedOption, setSelectedOption] = useState(null);
  const { id } = useParams();
  const [list, setList] = useState([]);
  const [data, setData] = useState([]);
  const [dataDeepCopy, setDataDeepCopy] = useState([]);
  const [inputs, setInputs] = useState({
    entry_date: new Date().toISOString().split("T")[0],
  });
  const [product, setProduct] = useState({});
  const [error, setError] = useState({});
  const [role, setRole] = useState("");
  const [receiveData, setReceiveData] = useState([]);
  const [receipeNotFound, setReceipeNotFound] = useState("Receipe Not Found");
  const [receipe, setRecipe] = useState([]);
  const [receipeForSet, setReceipeForSet] = useState([]);
  const [totalRMQuantitiesForSet, setTotalRMQuantitiesForSet] = useState({});
  const [DeparmenType, setDeparmenType] = useState(null);
  const [production, setProduction] = useState(0);
  const [totalProductionAndTotalTransfer, setTotalProductionAndTotalTransfer] =
    useState();
  const [totalRMQuantities, setTotalRMQuantities] = useState({});
  const [groupSetData, setGroupSetData] = useState();
  const [count, setCount] = useState();
  const [sets, setSets] = useState();
  const [productionQty, setProductionQty] = useState(0);

  const fetchData = async () => {
    try {
      const resRole = await Http.get("/staff-type-check");
      setRole(resRole.data);

      const resRequisition = await Http.get("/requisition-art/" + id);
      const items = resRequisition.data.items;

      const res4 = await Http.get(
        "/last-code-increment-by-one/companies/code/COM"
      );
      setInputs((values) => ({ ...values, code: res4.data }));

      const groupedArray = [];
      const noSetIdItems = [];

      items.forEach((item) => {
        if (item.set_id != null) {
          // Check if group for this set_id already exists
          const existingGroup = groupedArray.find(
            (group) => group.set_id === item.set_id
          );

          if (existingGroup) {
            existingGroup.items.push(item);
          } else {
            groupedArray.push({
              set_id: item.set_id,
              required_inner_qty: item.inner_qty || "",
              required_master_qty: item.master_qty || "",
              total_inner_qty: item.sets.total_inner_qty || "",
              total_master_qty: item.sets.total_master_qty || "",
              total_delivery_inner_qty:
                item.sets.total_delivery_inner_qty || "",
              total_delivery_master_qty:
                item.sets.total_delivery_master_qty || "",
              set_name: item.sets.name || "",
              items: [item],
            });
            // console.log(groupedArray);
          }
        } else {
          item.inner_qty = "";
          item.master_qty = "";
          noSetIdItems.push(item);
        }
      });

      // items without set_id

      setGroupSetData(groupedArray);
      setReceiveData(resRequisition.data);
      setList(noSetIdItems);
      setCount(noSetIdItems.length);

      // Filter total production and transfer data based on planning_item_ids from requisition
      const planningItemIds = resRequisition.data.items.map(
        (item) => item?.planning_item_id
      );
      const resTotalProduction = await Http.get(
        "/total-transfer-and-total-production/" + id
      );

      // Filter the response to only include relevant planning_item_ids
      const filteredTotalProduction = resTotalProduction.data.filter((item) =>
        planningItemIds.includes(item?.planning_item_id)
      );

      // Create a mapping for easy access
      const totalProductionMap = {};
      filteredTotalProduction.forEach((item) => {
        totalProductionMap[item?.planning_item_id] = {
          total_production_qty: item.total_production_qty,
          total_transfer_qty: item.total_delivery_qty, // Assuming this is the total transfer
          opening_balance:
            Number(item.total_production_qty) - Number(item.total_delivery_qty), // Assuming this is the total transfer
          total_production_qty_export: item.total_production_qty_export,
          total_delivery_export_qty: item.total_delivery_export_qty,
          // also a,b,c class
          total_production_qty_a: item.total_production_qty_a,
          total_delivery_a_class: item.total_delivery_a_class,
          total_production_qty_b: item.total_production_qty_b,
          total_delivery_b_class: item.total_delivery_b_class,
          total_production_qty_c: item.total_production_qty_c,
          total_delivery_c_class: item.total_delivery_c_class,
          total_production_inner_qty: item?.total_inner_qty,
          total_production_master_qty: item?.total_master_qty,
          total_delivery_inner_qty: item?.total_delivery_inner_qty,
          total_delivery_master_qty: item?.total_delivery_master_qty,
        };
      });

      setTotalProductionAndTotalTransfer(totalProductionMap);

      const resBatchNo = await Http.get(
        "/last-code-increment-by-one/requisition_arts/receipt_no/RD"
      );
      setInputs((values) => ({ ...values, ["receipt_no"]: resBatchNo.data }));

      if (
        resRequisition.data.to_department_art_id === 16 ||
        resRequisition.data.to_department_art_id === 19
      ) {
        setDeparmenType(resRequisition.data.to_department.user_type);
      } else {
        setDeparmenType(resRequisition.data.from_department.user_type);
      }
      if (resRequisition.data.to_department_art_id == 14) {
        setDeparmenType(resRequisition.data.department.user_type);
      }
    } catch (e) {
      console.error("Error fetching data:", e);
    }
  };

  // console.log(groupSetData, "groupSetData");
  // useEffect(() => {
  //   $("body").addClass("collapse-menu");
  //   fetchData();
  // }, []);
  // Handle Change for Inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const fetchReceipeData = async (productId) => {
    try {
      const updatedInputs = {
        receipt_no: inputs.receipt_no,
        product_id: productId,
      };
      const res = await Http.post("/receipe-load-stock-wise", updatedInputs);
      setData(res.data);
      setDataDeepCopy(res.data);
      if (res.data.status !== 1) {
        useEffect(() => {
          Swal.fire({
            icon: "error",
            title: "Out of Stock",
            text: "The selected product is out of stock.",
            confirmButtonText: "OK",
          });
        }, 3000);
      }
      if (res.data.list.length > 0) {
        setData(res.data.list);
        setDataDeepCopy(res.data.list);
        setInputs((prev) => ({
          ...prev,
          batch_size: prev.batch_size ? prev.batch_size : res.data.batch_size,
          receipe_id: res.data.info?.id || null,
        }));
        setReceipeNotFound("");
      } else {
        setData([]);
        setReceipeNotFound("No data found");
      }
    } catch (error) {
      console.error("Error loading receipe data:", error);
    }
  };

  useEffect(() => {
    fetchReceipeData();
  }, []);

  useEffect(() => {
    $("body").addClass("collapse-menu");
    const initializeData = async () => {
      await fetchData();
      await fetchInitialData();
    };
    initializeData();
  }, []);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setInputs((values) => ({ ...values, [name]: value }));
  // };

  const handleInputChange = (
    e,
    index,
    totalProduction = 0,
    totalTransfer = 0
  ) => {
    let { name, value } = e.target;
    let input = Number(value);

    let adjustedProduction = Number(totalProduction);

    // If field is production_qty, we want to add input value to totalProduction
    if (
      name === "production_qty" ||
      name === "qty_export" ||
      name === "qty_a_class" ||
      name === "qty_b_class" ||
      (name === "qty_c_class" && input > 0)
    ) {
      setProduction(input);
    }
    let errorFound = false;
    // console.log(input, "input");

    // If field is production_qty, we want to add input value to totalProduction
    const availableQty =
      adjustedProduction + production - Number(totalTransfer);

    if (
      name === "delivery_qty_a_class" ||
      name === "delivery_qty_b_class" ||
      name === "delivery_qty_c_class" ||
      name === "delivery_qty_export"
    ) {
      if (input > production + adjustedProduction) {
        Swal.fire({
          icon: "error",
          title: "Invalid Transfer",
          text: "Transfer can't be more than " + availableQty,
          confirmButtonText: "OK",
        });
        value = 0;
      }
    }

    const updatedList = [...list];
    let inputValue = value;

    // if (name === "transfer_qty") {
    //   const totalProductionQty = updatedList[index].total_production_qty || 0;
    //   const productionQty = parseFloat(updatedList[index].production_qty) || 0;
    //   const totalTransferQty = updatedList[index].total_transfer_qty || 0;

    //   const maxTransferQty =
    //     totalProductionQty + productionQty - totalTransferQty;

    //   // if (inputValue > maxTransferQty) {
    //   //   Swal.fire({
    //   //     icon: "error",
    //   //     title: "Validation Error",
    //   //     text: `Transfer quantity cannot exceed ${maxTransferQty}.`,
    //   //   });
    //   //   inputValue = maxTransferQty; // Reset to the maximum allowed value
    //   // }
    // }

    updatedList[index][name] = inputValue;
    setList(updatedList);
  };

  const fetchInitialData = async () => {
    try {
      const resRole = await Http.get("/staff-type-check");
      setRole(resRole.data);
      const resProduct = await Http.get("/receipe-finished-good");
      const latestProduct = resProduct.data[resProduct.data.length - 1];
      const productId = latestProduct.value;
      setProduct(latestProduct);
      fetchReceipeData(productId);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };
  const formSubmit = () => {
    if (checkRequiredFields() === true) {
      const concatReceipe = [...receipe, ...receipeForSet];
      // console.log(concatReceipe, "concatReceipe");

      const formData = {
        ...inputs,
        items: list,
        sets: sets,
        production_against_requisition_art_id: receiveData.id,
        production_against_requisition_issue_id: id,
        to_department_id: receiveData.from_department_art_id,
        planning_id: receiveData.from_department_art_id === 27 
                     ? 0 
                     : receiveData.planning_id,
        concatReceipe,
        entry_date: inputs.entry_date,
      };
      console.log(list);
      Http.post(`/production-transfer`, formData)
        .then((res) => {
          navigate("/department-requisition-jcg", {
            state: { message: res.data.message, type: "success" },
          });
        })
        .catch(function (e) {
          setError(e.response.data.errors);
        });
    }
  };

  const handleRecepieChange = async (
    e,
    stockQty,
    rmId,
    index,
    productIndex
  ) => {
    const { value } = e.target;
    let numericValue = Number(value);

    // Create a unique key for each repetition using rmId and productIndex
    const uniqueKey = `${rmId}_${productIndex}`;

    // Calculate total quantity used for this RM across all repetitions
    const currentTotals = { ...totalRMQuantities };
    const existingTotal = Object.values(receipe)
      .filter((item) => item.receipe_product_id === rmId)
      .reduce((sum, item) => sum + (Number(item.qty) || 0), 0);

    // Subtract the previous value for this specific input if it exists
    const previousValue =
      receipe.find(
        (item) =>
          item.receipe_product_id === rmId && item.uniqueKey === uniqueKey
      )?.qty || 0;

    const otherItemsTotal = existingTotal - previousValue;
    const newTotal = otherItemsTotal + numericValue;

    // Check if total quantity exceeds stock
    // if (newTotal > stockQty) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Out of Stock",
    //     text: `Total quantity across all items (${newTotal}). Which exceeds stock quantity (${stockQty}).`,
    //     confirmButtonText: "OK",
    //   });

    //   e.target.value = previousValue || 0; // Reset to previous value instead of 0
    //   numericValue = previousValue || 0;
    // }

    // Update recipe state with the new value
    setRecipe((prevRecipe) => {
      const existingIndex = prevRecipe.findIndex(
        (item) =>
          item.receipe_product_id === rmId && item.uniqueKey === uniqueKey
      );

      if (existingIndex !== -1) {
        return prevRecipe.map((item, idx) =>
          idx === existingIndex
            ? { ...item, receipe_id: rmId, qty: numericValue }
            : item
        );
      } else {
        return [
          ...prevRecipe,
          {
            receipe_id: rmId,
            receipe_product_id: rmId,
            qty: numericValue,
            itemIndex: index,
            uniqueKey,
            productIndex,
          },
        ];
      }
    });

    // Update total quantities
    setTotalRMQuantities((prev) => ({
      ...prev,
      [rmId]: newTotal,
    }));
  };

  const handleRecepieChangeForSet = async (
    e,
    stockQty,
    rmId,
    index,
    productIndex
  ) => {
    const { value } = e.target;
    let numericValue = Number(value);

    // Create a unique key for each repetition using rmId and productIndex
    const uniqueKey = `${rmId}_${productIndex}`;

    // Calculate total quantity used for this RM across all repetitions
    const currentTotals = { ...totalRMQuantities };
    const existingTotal = Object.values(receipeForSet)
      .filter((item) => item.receipe_product_id === rmId)
      .reduce((sum, item) => sum + (Number(item.qty) || 0), 0);

    // Subtract the previous value for this specific input if it exists
    const previousValue =
      receipeForSet.find(
        (item) =>
          item.receipe_product_id === rmId && item.uniqueKey === uniqueKey
      )?.qty || 0;

    const otherItemsTotal = existingTotal - previousValue;
    const newTotal = otherItemsTotal + numericValue;

    // Check if total quantity exceeds stock
    // if (newTotal > stockQty) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Out of Stock",
    //     text: `Total quantity across all items (${newTotal}). Which exceeds stock quantity (${stockQty}).`,
    //     confirmButtonText: "OK",
    //   });

    //   e.target.value = previousValue || 0; // Reset to previous value instead of 0
    //   numericValue = previousValue || 0;
    // }

    // Update recipe state with the new value
    setReceipeForSet((prevRecipe) => {
      const existingIndex = prevRecipe.findIndex(
        (item) =>
          item.receipe_product_id === rmId && item.uniqueKey === uniqueKey
      );

      if (existingIndex !== -1) {
        return prevRecipe.map((item, idx) =>
          idx === existingIndex
            ? { ...item, receipe_id: rmId, qty: numericValue }
            : item
        );
      } else {
        return [
          ...prevRecipe,
          {
            receipe_id: rmId,
            receipe_product_id: rmId,
            qty: numericValue,
            itemIndex: index,
            uniqueKey,
            productIndex,
          },
        ];
      }
    });

    // Update total quantities
    setTotalRMQuantitiesForSet((prev) => ({
      ...prev,
      [rmId]: newTotal,
    }));
  };

  // console.log("setTotalRMQuantities", totalRMQuantities);

  const [displayErrorMessage, setDisplayErrorMessage] = useState({
    qty_export: "",
    delivery_qty_export: "",
  });
  const [innerQty, setInnerQty] = useState(0);
  const [masterQty, setMasterQty] = useState(0);

  const handleNumberInputChange = (
    e,
    index,
    totalProduction = 0,
    totalTransfer = 0
  ) => {
    let { name, value } = e.target;
    const inputValue = Number(value);
    console.log("AJAKJSKJS");

    let adjustedProduction = Number(totalProduction);

    // If field is production_qty, we want to add input value to totalProduction
    if (
      name === "production_qty" ||
      name === "qty_export" ||
      name === "qty_a_class" ||
      name === "qty_b_class" ||
      (name === "qty_c_class" && inputValue > 0)
    ) {
      setProduction(inputValue);
      setProductionQty(inputValue);
    }

    // if (name === "transfer_qty" && inputValue > productionQty) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Validation Error",
    //     text: "Transfer quantity is greater than production quantity.",
    //     confirmButtonText: "OK",
    //   });
    //   e.target.value = 0; // Reset to the maximum allowed value
    // }

    if (name === "inner_qty") {
      setInnerQty(inputValue);
    }
    if (name === "master_qty") {
      setMasterQty(inputValue);
    }

    // if (name === "inner_transfer_qty") {
    //   if (inputValue > innerQty) {
    //     Swal.fire({
    //       icon: "error",
    //       title: "Validation Error",
    //       text: "Transfer quantity is greater than production quantity.",
    //       confirmButtonText: "OK",
    //     });
    //     e.target.value = 0;
    //   }
    // }
    // if (name === "master_transfer_qty") {
    //   if (inputValue > masterQty) {
    //     Swal.fire({
    //       icon: "error",
    //       title: "Validation Error",
    //       text: "Transfer quantity is greater than production quantity.",
    //       confirmButtonText: "OK",
    //     });
    //     e.target.value = 0;
    //   }
    // }

    const availableQty =
      adjustedProduction + production - Number(totalTransfer);

    if (totalProduction > 0 && totalTransfer > 0) {
      if (inputValue > availableQty) {
        Swal.fire({
          icon: "error",
          title: "Invalid Transfer",
          text: "Transfer can't be more than " + availableQty,
          confirmButtonText: "OK",
        });
        e.target.value = 0;
      }
    }
    if (/^\d*$/.test(value)) {
      const updatedList = [...list];

      if (name === "transfer_qty") {
        const totalProductionQty = updatedList[index].total_production_qty || 0;
        const productionQty =
          parseFloat(updatedList[index].production_qty) || 0;
        const totalTransferQty = updatedList[index].total_transfer_qty || 0;

        const maxTransferQty =
          totalProductionQty + productionQty - totalTransferQty;

        // if (inputValue > maxTransferQty) {
        //   Swal.fire({
        //     icon: "error",
        //     title: "Validation Error",
        //     text: `Transfer quantity cannot exceed ${maxTransferQty}.`,
        //   });
        //   inputValue = maxTransferQty; // Reset to the maximum allowed value
        // }

        setDisplayErrorMessage((prev) => ({ ...prev, [name]: "" })); // Clear error
      } else {
        setDisplayErrorMessage((prev) => ({ ...prev, [name]: "" })); // Clear error for numeric input
      }
      updatedList[index][name] = value;
      setList(updatedList);
    } else {
      setDisplayErrorMessage((prev) => ({
        ...prev,
        [name]: "Only numbers are allowed!",
      }));
    }
  };

  // console.log(list, "list");
  const handleNumberInputChangeForTransfer = (e, index) => {
    const { name, value } = e.target;
    const inputValue = Number(value);

    let updatedList = [...list];

    // Ensure only numeric input is accepted
    if (/^\d*$/.test(value)) {
      if (name === "master_qty" || name === "inner_qty") {
        // Update master_qty or inner_qty
        updatedList[index][name] = inputValue;
      } else if (
        name === "master_transfer_qty" ||
        name === "inner_transfer_qty"
      ) {
        // Validation for master_transfer_qty and inner_transfer_qty
        const masterQty = updatedList[index].master_qty || 0;
        const innerQty = updatedList[index].inner_qty || 0;

        if (name === "master_transfer_qty") {
          // Ensure master_transfer_qty doesn't exceed master_qty
          // if (inputValue > masterQty) {
          //   Swal.fire({
          //     icon: "error",
          //     title: "Validation Error",
          //     text: "Master transfer quantity cannot be greater than master quantity.",
          //     confirmButtonText: "OK",
          //   });
          //   updatedList[index].master_transfer_qty = 0; // Reset to 0 if invalid
          // } else {
          // Update master_transfer_qty
          updatedList[index].master_transfer_qty = inputValue;
          // }
        }

        if (name === "inner_transfer_qty") {
          // Ensure inner_transfer_qty doesn't exceed inner_qty
          // if (inputValue > innerQty) {
          //   Swal.fire({
          //     icon: "error",
          //     title: "Validation Error",
          //     text: "Inner transfer quantity cannot be greater than inner quantity.",
          //     confirmButtonText: "OK",
          //   });
          //   updatedList[index].inner_transfer_qty = 0; // Reset to 0 if invalid
          // } else {
          // Update inner_transfer_qty
          updatedList[index].inner_transfer_qty = inputValue;
          // }
        }
      }

      if (name === "inner_qty") {
        setInnerQty(inputValue);
      }
      if (name === "master_qty") {
        setMasterQty(inputValue);
      }

      // if (name === "inner_transfer_qty") {
      //   if (inputValue > innerQty) {
      //     Swal.fire({
      //       icon: "error",
      //       title: "Validation Error",
      //       text: "Transfer quantity is greater than production quantity.",
      //       confirmButtonText: "OK",
      //     });
      //     e.target.value = 0;
      //   }
      // }
      // if (name === "master_transfer_qty") {
      //   if (inputValue > masterQty) {
      //     Swal.fire({
      //       icon: "error",
      //       title: "Validation Error",
      //       text: "Transfer quantity is greater than production quantity.",
      //       confirmButtonText: "OK",
      //     });
      //     e.target.value = 0;
      //   }
      // }

      setList(updatedList); // Update the list state with the new values
      setDisplayErrorMessage((prev) => ({ ...prev, [name]: "" })); // Clear error message
    } else {
      // Show error if the input is not numeric
      setDisplayErrorMessage((prev) => ({
        ...prev,
        [name]: "Only numbers are allowed!",
      }));
    }
  };

  const handleNumberInputChangeForSet = (
    e,
    index,
    totalProduction = 0,
    totalTransfer = 0
  ) => {
    const { name, value } = e.target;
    const inputValue = Number(value);

    let adjustedProduction = Number(totalProduction);

    // If field is production_qty, we want to add input value to totalProduction
    if (
      name === "production_qty" ||
      name === "qty_export" ||
      name === "qty_a_class" ||
      name === "qty_b_class" ||
      (name === "qty_c_class" && inputValue > 0)
    ) {
      setProduction(inputValue);
    }

    const availableQty =
      adjustedProduction + production - Number(totalTransfer);

    if (totalProduction > 0 && totalTransfer > 0) {
      if (inputValue > availableQty) {
        Swal.fire({
          icon: "error",
          title: "Invalid Transfer",
          text: "Transfer can't be more than " + availableQty,
          confirmButtonText: "OK",
        });
        e.target.value = 0;
      }
    }
    if (/^\d*$/.test(value)) {
      // const lists = Array.isArray(groupSetData)
      // ? groupSetData.flatMap(group => group.items)
      // : [];
      // const updatedList = [...lists];
      const updatedList = [...groupSetData];
      // const concat = updatedList.concat(lists);

      if (name === "transfer_qty") {
        const totalProductionQty = updatedList[index].total_production_qty || 0;
        const productionQty =
          parseFloat(updatedList[index].production_qty) || 0;
        const totalTransferQty = updatedList[index].total_transfer_qty || 0;

        const maxTransferQty =
          totalProductionQty + productionQty - totalTransferQty;
        setDisplayErrorMessage((prev) => ({ ...prev, [name]: "" })); // Clear error
      } else {
        setDisplayErrorMessage((prev) => ({ ...prev, [name]: "" })); // Clear error for numeric input
      }

      if (name === "inner_qty") {
        // console.log("ABC", inputValue);

        setInnerQty(inputValue);
      }
      if (name === "master_qty") {
        setMasterQty(inputValue);
      }

      // if (name === "inner_transfer_qty") {
      //   if (inputValue > innerQty) {
      //     Swal.fire({
      //       icon: "error",
      //       title: "Validation Error",
      //       text: "Transfer quantity is greater than production quantity.",
      //       confirmButtonText: "OK",
      //     });
      //     e.target.value = 0;
      //   }
      // }
      // if (name === "master_transfer_qty") {
      //   if (inputValue > masterQty) {
      //     Swal.fire({
      //       icon: "error",
      //       title: "Validation Error",
      //       text: "Transfer quantity is greater than production quantity.",
      //       confirmButtonText: "OK",
      //     });
      //     e.target.value = 0;
      //   }
      // }

      updatedList[index][name] = value;
      setSets(updatedList);
    } else {
      setDisplayErrorMessage((prev) => ({
        ...prev,
        [name]: "Only numbers are allowed!",
      }));
    }
  };

  // console.log(list, "inputs");
  // console.log(sets, "inputs");

  // Add this function, for example, right after your imports or at the top of your component file.
const isProductQtyFieldsEmpty = (productItem) => {
  if (!productItem) return true; // If no product item, consider fields as empty

  const fieldsToCheck = [
    'production_qty',
    'qty_export',
    'qty_a_class',
    'qty_b_class',
    'qty_c_class',
    'inner_qty', // Applies to PStore items
    'master_qty' // Applies to PStore items
  ];

  // Returns true if ALL fields are empty or zero, false if ANY is filled.
  return !fieldsToCheck.some(field => {
    const value = productItem[field];
    // Check if the value is defined, not null, not an empty string, and not numerically zero.
    // We use String(value).trim() !== '' to handle cases where value might be a string "0" or just ""
    // We use Number(value) !== 0 to ensure that actual numeric 0 also counts as empty.
    return value !== undefined && value !== null && String(value).trim() !== '' && Number(value) !== 0;
  });
};



  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Production and Deliver</h5>
        </div>
        <div className="am-pagebody row d-flex justify-content-evenly">
          <div className="card pd-20 pd-sm-40 col-11">
            <h6 className="card-body-title mg-sm-b-30">
              Production and Delivery
            </h6>
            {/* <p>Transfer To Department {inputs.to_department}</p> */}
            <div className="row">
              <div className="col-lg">
                <label>Receipt No</label>
                <input
                  type="text"
                  className="form-control"
                  name="receipt_no"
                  value={inputs.receipt_no}
                  disabled
                />
              </div>
              <div className="col-lg">
                <label>Entry Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="entry_date"
                  value={inputs.entry_date}
                  onChange={handleChange}
                />
              </div>

              <div className="col-lg">
                <label>Shift</label>
                <select
                  className="form-control"
                  name="shift"
                  value={inputs.shift}
                  data-required
                  onChange={handleChange}
                >
                  <option value="">Select Shift</option>
                  <option value="a">A</option>
                  <option value="b">B</option>
                  <option value="c">C</option>
                  <option value="general">General</option>
                </select>
              </div>

              <div className="col-lg">
                <label>Remarks</label>
                <textarea
                  className="form-control"
                  name="remarks"
                  value={inputs.remarks}
                />
              </div>
            </div>

            {/* Item List */}
            <div className="row mt-3">
              <div className="card-solid">
                <div className="card-header with-border text-center">
                  <h5 className="card-title mb-0">Items in the Production</h5>
                </div>
              </div>
              <div className="col-lg">
                <table className="table table-sm">
                  <thead>
                    <tr>
                      {role === "dstore" && (
                        <>
                          {(DeparmenType === "packing_export" ||
                            DeparmenType === "decoration_export") && (
                            <>
                              <th className="text-center" colSpan={5}>
                                Export Class
                              </th>
                            </>
                          )}
                          {(DeparmenType === "packing_local" ||
                            DeparmenType === "decoration_local") && (
                            <>
                              <th className="text-center" colSpan={6}>
                                A Class
                              </th>
                              <th className="text-center" colSpan={6}>
                                B Class
                              </th>
                              <th className="text-center" colSpan={5}>
                                C Class
                              </th>
                            </>
                          )}
                        </>
                      )}
                    </tr>
                    <tr>
                      {(DeparmenType === "mould" ||
                        DeparmenType === "sagger") && (
                        <>
                          <th colSpan={2}>Product Name</th>
                          {DeparmenType === "mould" && <th>Shape</th>}
                          <th>Required</th>
                          {(DeparmenType === "mould" || role === "sagger") && (
                            <th>Opening Balance</th>
                          )}
                          <th>Total Production</th>
                          <th>Production</th>
                          <th>Total Transfer</th>
                          <th>Transfer</th>
                        </>
                      )}
                    </tr>
                    <tr>
                      {role === "pstore" && (
                        <>
                          {/* {(DeparmenType === "packing_export" || DeparmenType === "packing_local") && (<> */}
                          <th colSpan={2}>Product Name</th>
                          <th>Shape</th>
                          <th className="text-center">
                            Total Production Inner Qty
                          </th>
                          <th className="text-center">
                            Opening Stock Inner Qty
                          </th>
                          <th className="text-center">Required Inner Qty</th>
                          <th className="text-center">Production Inner Qty</th>
                          <th className="text-center">
                            Total Transfer Inner Qty
                          </th>
                          <th className="text-center">Transfer Inner Qty</th>
                          <th className="text-center">Remaining Inner Qty</th>
                          <th className="text-center">
                            Total Production Master Qty
                          </th>
                          <th className="text-center">
                            Opening Stock Master Qty
                          </th>
                          <th className="text-center">Required Master Qty</th>
                          <th className="text-center">Production Master Qty</th>
                          <th className="text-center">
                            Total Transfer Master Qty
                          </th>
                          <th className="text-center">Transfer Master Qty</th>
                          <th className="text-center">Remaining Master Qty</th>
                          {/* </>)} */}
                        </>
                      )}
                    </tr>
                    <tr>
                      {role === "dstore" && (
                        <>
                          {DeparmenType === "decoration_export" && (
                            <>
                              <th colSpan={2}>Product Name</th>
                              <th>Required</th>
                              <th>Total Production</th>
                              <th>Production</th>
                              <th>Total Transfer</th>
                              <th>Transfer</th>
                            </>
                          )}
                          {DeparmenType === "decoration_local" && (
                            <>
                              <th colSpan={2}>Product Name</th>
                              <th>Required</th>
                              <th>Total Production</th>
                              <th>Production</th>
                              <th>Total Transfer</th>
                              <th>Transfer</th>
                              <th>Required</th>
                              <th>Total Production</th>
                              <th>Production</th>
                              <th>Total Transfer</th>
                              <th>Transfer</th>
                              <th>Required</th>
                              <th>Total Production</th>
                              <th>Production</th>
                              <th>Total Transfer</th>
                              <th>Transfer</th>
                            </>
                          )}
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {list.map((item, productIndex) => {
                      // setCount(productIndex);
                      return (
                        <>
                          <tr key={productIndex}>
                            <td colSpan={2}>
                              {item.product?.name}
                              || {item.product?.code} <br />
                            </td>

                            {(DeparmenType === "mould" ||
                              role === "pstore") && <td>{item.shape?.name}</td>}

                            {(DeparmenType === "mould" ||
                              DeparmenType === "sagger") && (
                              <>
                                <td>{item.required_qty}</td>
                                {/* {DeparmenType === "mould" && ( */}
                                  <td>
                                    {/* {(totalProductionAndTotalTransfer &&
                                      totalProductionAndTotalTransfer[
                                        item?.planning_item_id
                                      ]?.opening_balance + productionQty) ||
                                      0} */}
                                    {item.current_stock ||
                                      0}
                                  </td>
                                {/* )} */}
                                <td>
                                  {(totalProductionAndTotalTransfer &&
                                    totalProductionAndTotalTransfer[
                                      item?.planning_item_id
                                    ]?.total_production_qty) ||
                                    0}
                                </td>
                                <td>
                                  <div className="input-group mb-3">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="production_qty"
                                      onChange={(e) =>
                                        handleNumberInputChange(e, productIndex)
                                      }
                                      // data-required
                                    />
                                    <span className="input-group-text">
                                      {item?.product?.unit?.name}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  {(totalProductionAndTotalTransfer &&
                                    totalProductionAndTotalTransfer[
                                      item?.planning_item_id
                                    ]?.total_transfer_qty) ||
                                    0}
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="transfer_qty"
                                    onChange={(e) =>
                                      handleNumberInputChange(
                                        e,
                                        productIndex,
                                        totalProductionAndTotalTransfer[
                                          item?.planning_item_id
                                        ]?.total_production_qty,
                                        totalProductionAndTotalTransfer[
                                          item?.planning_item_id
                                        ]?.total_transfer_qty
                                      )
                                    }
                                  />
                                </td>
                              </>
                            )}
                            {role === "dstore" && (
                              <>
                                {DeparmenType === "decoration_export" && (
                                  <>
                                    <td>{item.required_qty_export}</td>
                                    <td>
                                      {(totalProductionAndTotalTransfer &&
                                        totalProductionAndTotalTransfer[
                                          item?.planning_item_id
                                        ]?.total_production_qty_export) ||
                                        0}
                                    </td>
                                    <td>
                                      <div className="input-group mb-3">
                                        <input
                                          type="text"
                                          className="form-control"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          name="qty_export"
                                          defaultValue={
                                            list[productIndex]?.qty_export || ""
                                          }
                                          onChange={(e) =>
                                            handleNumberInputChange(
                                              e,
                                              productIndex
                                            )
                                          }
                                        />
                                        <span className="input-group-text">
                                          {item?.product?.unit?.name}
                                        </span>
                                      </div>

                                      <div className="input-group mb-3">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="loss_qty_export"
                                          // onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                          // defaultValue={list[index]?.production_qty || ""}
                                          placeholder="Loss qty export"
                                          onChange={(e) =>
                                            handleNumberInputChange(
                                              e,
                                              productIndex
                                            )
                                          }
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      {(totalProductionAndTotalTransfer &&
                                        totalProductionAndTotalTransfer[
                                          item?.planning_item_id
                                        ]?.total_delivery_export_qty) ||
                                        0}
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        className="form-control"
                                        onInput={(e) =>
                                          (e.target.value =
                                            e.target.value.replace(/\D/g, ""))
                                        }
                                        name="delivery_qty_export"
                                        defaultValue={
                                          list[productIndex]
                                            ?.delivery_qty_export || ""
                                        }
                                        onChange={(e) =>
                                          handleNumberInputChange(
                                            e,
                                            productIndex,
                                            totalProductionAndTotalTransfer?.totalProductionExport,
                                            totalProductionAndTotalTransfer?.totalProductionExportTransfer
                                          )
                                        }
                                      />
                                    </td>
                                  </>
                                )}
                                {DeparmenType === "decoration_local" && (
                                  <>
                                    <td>{item.required_qty_a}</td>
                                    <td>
                                      {(totalProductionAndTotalTransfer &&
                                        totalProductionAndTotalTransfer[
                                          item?.planning_item_id
                                        ]?.total_production_qty_a) ||
                                        0}
                                    </td>
                                    <td>
                                      <div className="input-group mb-3">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="qty_a_class"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          value={
                                            list[productIndex]?.qty_a_class ||
                                            ""
                                          }
                                          onChange={(e) =>
                                            handleInputChange(e, productIndex)
                                          }
                                        />
                                        <span className="input-group-text">
                                          {item?.product?.unit?.name}
                                        </span>
                                      </div>
                                      <div className="input-group mb-3">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="loss_qty_a_class"
                                          // onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                          defaultValue="0"
                                          placeholder="Loss qty A class"
                                          onChange={(e) =>
                                            handleNumberInputChange(
                                              e,
                                              productIndex
                                            )
                                          }
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      {(totalProductionAndTotalTransfer &&
                                        totalProductionAndTotalTransfer[
                                          item?.planning_item_id
                                        ]?.total_delivery_a_class) ||
                                        0}
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        className="form-control"
                                        onInput={(e) =>
                                          (e.target.value =
                                            e.target.value.replace(/\D/g, ""))
                                        }
                                        name="delivery_qty_a_class"
                                        value={
                                          list[productIndex]
                                            ?.delivery_qty_a_class || ""
                                        }
                                        onChange={(e) =>
                                          handleInputChange(
                                            e,
                                            productIndex,
                                            totalProductionAndTotalTransfer[
                                              item?.planning_item_id
                                            ]?.total_production_qty_a,
                                            totalProductionAndTotalTransfer[
                                              item?.planning_item_id
                                            ]?.total_delivery_a_class
                                          )
                                        }
                                      />
                                    </td>
                                    <td>{item.required_qty_b}</td>
                                    <td>
                                      {(totalProductionAndTotalTransfer &&
                                        totalProductionAndTotalTransfer[
                                          item?.planning_item_id
                                        ]?.total_production_qty_b) ||
                                        0}
                                    </td>
                                    <td>
                                      <div className="input-group mb-3">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="qty_b_class"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          value={
                                            list[productIndex]?.qty_b_class ||
                                            ""
                                          }
                                          onChange={(e) =>
                                            handleInputChange(e, productIndex)
                                          }
                                        />
                                        <span className="input-group-text">
                                          {item?.product?.unit?.name}
                                        </span>
                                      </div>
                                      <div className="input-group mb-3">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="loss_qty_b_class"
                                          // onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                          defaultValue="0"
                                          placeholder="Loss qty B class"
                                          onChange={(e) =>
                                            handleNumberInputChange(
                                              e,
                                              productIndex
                                            )
                                          }
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      {(totalProductionAndTotalTransfer &&
                                        totalProductionAndTotalTransfer[
                                          item?.planning_item_id
                                        ]?.total_delivery_b_class) ||
                                        0}
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="delivery_qty_b_class"
                                        value={
                                          list[productIndex]
                                            ?.delivery_qty_b_class || ""
                                        }
                                        onChange={(e) =>
                                          handleInputChange(
                                            e,
                                            productIndex,
                                            totalProductionAndTotalTransfer[
                                              item?.planning_item_id
                                            ]?.total_production_qty_b,
                                            totalProductionAndTotalTransfer[
                                              item?.planning_item_id
                                            ]?.total_delivery_b_class
                                          )
                                        }
                                        onInput={(e) =>
                                          (e.target.value =
                                            e.target.value.replace(/\D/g, ""))
                                        }
                                      />
                                    </td>
                                    <td>{item.required_qty_c}</td>
                                    <td>
                                      {(totalProductionAndTotalTransfer &&
                                        totalProductionAndTotalTransfer[
                                          item?.planning_item_id
                                        ]?.total_production_qty_c) ||
                                        0}
                                    </td>
                                    <td>
                                      <div className="input-group mb-3">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="qty_c_class"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          value={
                                            list[productIndex]?.qty_c_class ||
                                            ""
                                          }
                                          onChange={(e) =>
                                            handleInputChange(e, productIndex)
                                          }
                                        />
                                        <span className="input-group-text">
                                          {item?.product?.unit?.name}
                                        </span>
                                      </div>
                                      <div className="input-group mb-3">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="loss_qty_c_class"
                                          // onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                          defaultValue="0"
                                          placeholder="Loss qty C class"
                                          onChange={(e) =>
                                            handleNumberInputChange(
                                              e,
                                              productIndex
                                            )
                                          }
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      {(totalProductionAndTotalTransfer &&
                                        totalProductionAndTotalTransfer[
                                          item?.planning_item_id
                                        ]?.total_delivery_c_class) ||
                                        0}
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="delivery_qty_c_class"
                                        value={
                                          list[productIndex]
                                            ?.delivery_qty_c_class || ""
                                        }
                                        onChange={(e) =>
                                          handleInputChange(
                                            e,
                                            productIndex,
                                            totalProductionAndTotalTransfer[
                                              item?.planning_item_id
                                            ]?.total_production_qty_c,
                                            totalProductionAndTotalTransfer[
                                              item?.planning_item_id
                                            ]?.total_delivery_c_class
                                          )
                                        }
                                      />
                                    </td>
                                  </>
                                )}
                              </>
                            )}

                            {role === "pstore" && (
                              <>
                                {/* {(DeparmenType === "packing_export") && (
                                  <> */}
                                <td>
                                  {(totalProductionAndTotalTransfer &&
                                    totalProductionAndTotalTransfer[
                                      item?.planning_item_id
                                    ]?.total_production_inner_qty) ||
                                    0}
                                </td>
                                <td>
                                  {item?.current_stock_inner_qty ||
                                    0}
                                  {/* {(totalProductionAndTotalTransfer &&
                                    totalProductionAndTotalTransfer[
                                      item?.planning_item_id
                                    ]?.total_production_inner_qty -
                                      totalProductionAndTotalTransfer[
                                        item?.planning_item_id
                                      ]?.total_delivery_inner_qty) ||
                                    0} */}
                                </td>
                                <td>{item.required_inner_qty}</td>
                                <td>
                                  <div className="input-group mb-3">
                                    <input
                                      type="text"
                                      className="form-control"
                                      onInput={(e) =>
                                        (e.target.value =
                                          e.target.value.replace(/\D/g, ""))
                                      }
                                      name="inner_qty"
                                      placeholder="Inner Qty"
                                      // defaultValue={list[productIndex]?.qty_export || ""}
                                      onChange={(e) =>
                                        handleNumberInputChange(e, productIndex)
                                      }
                                    />
                                  </div>
                                </td>
                                <td>
                                  {(totalProductionAndTotalTransfer &&
                                    totalProductionAndTotalTransfer[
                                      item?.planning_item_id
                                    ]?.total_delivery_inner_qty) ||
                                    0}
                                </td>
                                <td>
                                  <div className="input-group mb-3">
                                    <input
                                      type="text"
                                      className="form-control"
                                      onInput={(e) =>
                                        (e.target.value =
                                          e.target.value.replace(/\D/g, ""))
                                      }
                                      name="inner_transfer_qty"
                                      placeholder="Inner Transfer Qty"
                                      // defaultValue={list[productIndex]?.qty_export || ""}
                                      onChange={(e) =>
                                        handleNumberInputChangeForTransfer(
                                          e,
                                          productIndex
                                        )
                                      }
                                    />
                                  </div>
                                </td>
                                {/* <td> {item.required_inner_qty} -
                                {totalProductionAndTotalTransfer && totalProductionAndTotalTransfer[
                                    item?.planning_item_id
                                  ]?.total_delivery_inner_qty || 0}
                                </td> */}
                                <td>
                                  {item.required_inner_qty -
                                    ((totalProductionAndTotalTransfer &&
                                      totalProductionAndTotalTransfer[
                                        item?.planning_item_id
                                      ]?.total_delivery_inner_qty) ||
                                      0)}
                                </td>
                                <td>
                                  {(totalProductionAndTotalTransfer &&
                                    totalProductionAndTotalTransfer[
                                      item?.planning_item_id
                                    ]?.total_production_master_qty) ||
                                    0}
                                </td>
                                <td>
                                  {item?.current_stock_master_qty ||
                                    0}
                                  {/* {(totalProductionAndTotalTransfer &&
                                    totalProductionAndTotalTransfer[
                                      item?.planning_item_id
                                    ]?.total_production_master_qty -
                                      totalProductionAndTotalTransfer[
                                        item?.planning_item_id
                                      ]?.total_delivery_master_qty) ||
                                    0} */}
                                </td>
                                <td>{item.required_master_qty}</td>
                                <td>
                                  <div className="input-group mb-3">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Master Qty"
                                      onInput={(e) =>
                                        (e.target.value =
                                          e.target.value.replace(/\D/g, ""))
                                      }
                                      name="master_qty"
                                      // defaultValue={list[productIndex]?.qty_export || ""}
                                      onChange={(e) =>
                                        handleNumberInputChange(e, productIndex)
                                      }
                                    />
                                  </div>
                                </td>
                                <td>
                                  {(totalProductionAndTotalTransfer &&
                                    totalProductionAndTotalTransfer[
                                      item?.planning_item_id
                                    ]?.total_delivery_master_qty) ||
                                    0}
                                </td>
                                <td>
                                  <div className="input-group mb-3">
                                    <input
                                      type="text"
                                      placeholder="Master Transfer Qty"
                                      className="form-control"
                                      onInput={(e) =>
                                        (e.target.value =
                                          e.target.value.replace(/\D/g, ""))
                                      }
                                      name="master_transfer_qty"
                                      // defaultValue={list[productIndex]?.qty_export || ""}
                                      onChange={(e) =>
                                        handleNumberInputChangeForTransfer(
                                          e,
                                          productIndex
                                        )
                                      }
                                    />
                                  </div>
                                </td>
                                <td>
                                  {item.required_master_qty -
                                    ((totalProductionAndTotalTransfer &&
                                      totalProductionAndTotalTransfer[
                                        item?.planning_item_id
                                      ]?.total_delivery_master_qty) ||
                                      0)}
                                </td>
                              </>
                              //   )}
                              // </>
                            )}
                          </tr>
                          <tr>
                            {data.length > 0 && (
                              <>
                                <th>Receipe Name</th>
                                {role !== "dstore" && role !== "pstore" && (
                                  <>
                                    <th>Stock</th>
                                    <th>Qty</th>
                                  </>
                                )}
                              </>
                            )}
                          </tr>
                          {data.status != 0 &&
                            data.map((listItem, recipeIndex) => (
                              <tr
                                key={recipeIndex}
                                style={{ backgroundColor: "#d2d5d7" }}
                              >
                                <td colSpan={3}>
                                  <span className="my-3 d-flex gx-5">
                                    {listItem.name}
                                  </span>
                                </td>
                                <td colSpan={2}>
                                  <>{listItem?.stockQty}</>
                                </td>
                                <td colSpan={13}>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Please input total qty"
                                    onChange={(e) =>
                                      handleRecepieChange(
                                        e,
                                        listItem?.stockQty,
                                        listItem.id,
                                        recipeIndex,
                                        productIndex
                                      )
                                    }
                                    name="standard_qty"
                                    value={
                                      receipe.find(
                                        (item) =>
                                          item.receipe_product_id ===
                                            listItem.id &&
                                          item.uniqueKey ===
                                            `${listItem.id}_${productIndex}`
                                      )?.qty || ""
                                    }
                                    readOnly={isProductQtyFieldsEmpty(list[productIndex])}
                                  />
                                  {/* <small className="text-muted">
                                Total used: {totalRMQuantities[listItem.id] || 0} / {listItem?.stockQty}
                              </small> */}
                                </td>
                              </tr>
                            ))}
                        </>
                      );
                    })}
                    {role === "pstore" && (
                      <>
                        <tr>
                          {/* {(role === "pstore") && (
                            <> */}
                          {/* {(DeparmenType === "packing_export" || DeparmenType === "packing_local") && (<> */}
                          {/* {groupSetData && (
                            <th className="" colSpan={2}>
                              Set Name
                            </th>
                          )}  */}
                          {/* <th className="text-center">Total Production Inner Qty</th>
                          <th className="text-center">Required Inner Qty</th>
                          <th className="text-center">Inner Transfer Qty</th>
                          <th className="text-center">Required Master Qty</th>
                          <th className="text-center">Total Production Master Qty</th>
                          <th className="text-center">Master Transfer Qty</th> */}
                          {/* </>)} */}
                          {/* </>
                          )} */}
                        </tr>

                        {groupSetData?.map((i, productIndex) => {
                          return (
                            <>
                              <tr key={productIndex}>
                                <td colSpan={3}>
                                  <strong>Set Name: {i.set_name}</strong>

                                  <br />
                                  <div className="py-2">
                                    <ul style={{ listStyle: "none" }}>
                                      {i?.items.map((item) => {
                                        return (
                                          <>
                                            <li>* {item.product.name}</li>
                                          </>
                                        );
                                      })}
                                    </ul>
                                  </div>
                                </td>
                                {role === "pstore" && (
                                  <>
                                    {/* {(DeparmenType === "packing_export") && ( */}
                                    <>
                                      <td>{i?.total_inner_qty}</td>
                                      <td>
                                        {i?.total_inner_qty -
                                          i?.total_delivery_inner_qty}
                                      </td>
                                      <td>{i?.required_inner_qty}</td>
                                      <td>
                                        <div className="input-group mb-3">
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Inner qty"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  ""
                                                ))
                                            }
                                            name="inner_qty"
                                            // defaultValue={list[productIndex]?.qty_export || ""}
                                            onChange={(e) =>
                                              handleNumberInputChangeForSet(
                                                e,
                                                productIndex
                                              )
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td>{i?.total_delivery_inner_qty}</td>
                                      <td>
                                        <div className="input-group mb-3">
                                          <input
                                            type="text"
                                            className="form-control"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  ""
                                                ))
                                            }
                                            placeholder="Inner transfer qty"
                                            name="inner_transfer_qty"
                                            // defaultValue={list[productIndex]?.qty_export || ""}
                                            onChange={(e) =>
                                              handleNumberInputChangeForSet(
                                                e,
                                                productIndex
                                              )
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        {i.required_inner_qty -
                                          ((totalProductionAndTotalTransfer &&
                                            totalProductionAndTotalTransfer[
                                              i?.planning_item_id
                                            ]?.total_delivery_inner_qty) ||
                                            0)}
                                      </td>
                                      <td>{i?.total_master_qty}</td>
                                      <td>
                                        {i?.total_master_qty -
                                          i?.total_delivery_master_qty}
                                      </td>
                                      <td>{i?.required_master_qty}</td>
                                      <td>
                                        <div className="input-group mb-3">
                                          <input
                                            type="text"
                                            className="form-control"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  ""
                                                ))
                                            }
                                            placeholder="Master qty"
                                            name="master_qty"
                                            // defaultValue={list[productIndex]?.qty_export || ""}
                                            onChange={(e) =>
                                              handleNumberInputChangeForSet(
                                                e,
                                                productIndex
                                              )
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td>{i?.total_delivery_master_qty}</td>
                                      <td>
                                        <div className="input-group mb-3">
                                          <input
                                            type="text"
                                            className="form-control"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  ""
                                                ))
                                            }
                                            name="master_transfer_qty"
                                            placeholder="Master Transfer Qty"
                                            // defaultValue={list[productIndex]?.qty_export || ""}
                                            onChange={(e) =>
                                              handleNumberInputChangeForSet(
                                                e,
                                                productIndex
                                              )
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        {i.required_master_qty -
                                          ((totalProductionAndTotalTransfer &&
                                            totalProductionAndTotalTransfer[
                                              i?.planning_item_id
                                            ]?.total_delivery_master_qty) ||
                                            0)}
                                      </td>
                                    </>
                                    {/* )} */}
                                  </>
                                )}
                              </tr>
                              {dataDeepCopy.status != 0 &&
                                dataDeepCopy?.map((listItem, recipeIndex) => {
                                  return (
                                    <tr
                                      key={recipeIndex}
                                      style={{ backgroundColor: "#d2d5d7" }}
                                    >
                                      <td colSpan={3}>
                                        <span className="my-3 d-flex gx-5">
                                          {listItem.name}
                                        </span>
                                      </td>
                                      <td colSpan={2}>
                                        <>{listItem?.stockQty}</>
                                      </td>
                                      <td colSpan={13}>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="qty"
                                          onChange={(e) =>
                                            handleRecepieChangeForSet(
                                              e,
                                              listItem?.stockQty,
                                              listItem.id,
                                              recipeIndex,
                                              productIndex
                                            )
                                          }
                                          name="standard_qty"
                                          value={
                                            receipeForSet.find(
                                              (item) =>
                                                item.receipe_product_id ===
                                                  listItem.id &&
                                                item.uniqueKey ===
                                                  `${listItem.id}_${productIndex}`
                                            )?.qty || ""
                                          }
                                          readOnly={isProductQtyFieldsEmpty(list[productIndex])}
                                        />
                                        {/* <small className="text-muted">
                                Total used: {totalRMQuantities[listItem.id] || 0} / {listItem?.stockQty}
                              </small> */}
                                      </td>
                                    </tr>
                                  );
                                })}
                            </>
                          );
                        })}
                      </>
                    )}
                  </tbody>
                </table>
                {/* <div className="card-header with-border text-center">
                  <h5 className="card-title mb-0">Items in the List</h5>
                </div>
                <table className="table table-sm table-bordered table-striped mb-0">
                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>Product</th>
                      <th>Standard Qty</th>
                      <th>Stock Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 ? (
                      data.map((item, index) => (
                        <tr key={index}>
                          <td>{item.code}</td>
                          <td> <div className="input-group mb-3">{item.name}</div> </td>
                          <td>
                            <div className="input-group mb-3">
                              <input type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')} className="form-control" name="recipe_qty" onChange={(e) => handleRecepieChange(e, item.stockQty)} />
                              <span className="input-group-text">{item?.unit?.name}</span>
                            </div>
                          </td>
                          <td>{item.stockQty}</td>
                          <td></td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center">
                          {receipeNotFound}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table> */}
              </div>
            </div>
            {/* <div className="row mt-3">
              <div className="card-solid">
                <div className="card-header with-border text-center">
                  <h5 className="card-title mb-0">Items in the List</h5>
                </div>
                <div className="card-body mt-3 p-0 pt-3">
                  <table className="table table-sm table-bordered table-striped mb-0">
                    <thead>
                      <tr>
                        <th>Code</th>
                        <th>Product</th>
                        <th>Standard Qty</th>
                        <th>Stock Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.length > 0 ? (
                        list.map((item, index) => (
                          <tr key={index}>
                            <td>{item.code}</td>
                            <td>{item.name}</td>
                            <td><div className="input-group mb-3">{item.stndrd_qty}</div> </td>
                            <td>{item?.stockQty}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="text-center">
                            {receipeNotFound}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div> */}

            <div className="row mt-3">
              <div className="col-3">
                <button className="btn btn-primary" onClick={formSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;
